import { Box, InputAdornment, Stack, Typography } from '@mui/material';

import Table, { Object } from 'components/Common/StyledTable';
import { DateFilter } from './DateFilter';
import TextInput from './TextInput';
interface ParishonerActivityProps {
    navigationHandler: Function;
    records: Array<any>;
    columns: Array<{ id: string; label: string }>;
    textInputPlaceholders?: Array<string>;
    showDeleteCell?: boolean;
    onDeleteClick?: (value: Object) => void;
    setFilter?: any;
    filter?: any;
    defaultPagination?: boolean;
    disabledDateFilter?: boolean;
    value?: string | number;
    onTemplatebuttonclick?: () => void;
    getStartedTemplate?: boolean;
    templateButtonText?: string;
    loading?: boolean;
    serverSidePagination?: boolean;
    totalCount?: number;
    totalSent?: string | number;
    totalTransactions?: string | number;
    filterTitle?: string;
    intialFilter?: string;
}

function ActivityContainer({
    totalTransactions,
    navigationHandler,
    records,
    columns,
    showDeleteCell,
    onDeleteClick,
    setFilter,
    textInputPlaceholders,
    filter,
    defaultPagination,
    disabledDateFilter,
    onTemplatebuttonclick,
    getStartedTemplate,
    templateButtonText,
    serverSidePagination,
    totalCount,
    loading,
    filterTitle,
    intialFilter,
}: ParishonerActivityProps) {
    return (
        <Stack sx={{ backgroundColor: 'white' }}>
            <Box style={{ paddingTop: 8, marginTop: 8 }}>
                <Box>
                    <Typography fontSize={22} mb={-2}>
                        {filterTitle || 'Transaction History'}
                    </Typography>
                    <DateFilter intialFilter={intialFilter} disabled={disabledDateFilter} setFilter={setFilter} filter={filter} />
                </Box>
                {textInputPlaceholders ? (
                    <div style={{ display: 'flex', gap: '40px', width: '50%', marginBottom: '15px', fontWeight: 'bold' }}>
                        {/* <TextInput
                            backgroundColor="#F2F2F6"
                            height={50}
                            width={'40%'}
                            icon={null}
                            disabled
                            value={textInputPlaceholders?.[0]}
                            InputProps={{
                                endAdornment: <InputAdornment position="end">{totalSent}</InputAdornment>,
                            }}
                        /> */}
                        <TextInput
                            backgroundColor="#F2F2F6"
                            height={50}
                            width={'40%'}
                            icon={null}
                            disabled
                            value={textInputPlaceholders?.[1]}
                            InputProps={{
                                endAdornment: <InputAdornment position="end">{totalTransactions}</InputAdornment>,
                            }}
                        />
                    </div>
                ) : null}

                <Table
                    onDeleteClick={onDeleteClick}
                    showDeleteCell={showDeleteCell}
                    successValue="Complete"
                    navigationHandler={navigationHandler}
                    loadData={(filters: any) => setFilter && setFilter((pre: any) => ({ ...pre, ...filters }))}
                    defaultPagination={defaultPagination}
                    columns={columns}
                    data={records}
                    onTemplatebuttonclick={onTemplatebuttonclick}
                    getStartedTemplate={getStartedTemplate}
                    templateButtonText={templateButtonText}
                    serverSidePagination={serverSidePagination}
                    totalCount={totalCount}
                    loading={loading}
                />
            </Box>
        </Stack>
    );
}

export default ActivityContainer;
